import * as bootstrap from 'bootstrap';

window.bootstrap = bootstrap;

(() => {
    if (sessionStorage.reloaded) {
        return;
    }

    let previous;
    try {
        previous = new URL(sessionStorage.previous)
    } catch (err) {
        return;
    }
    if (previous.origin !== location.origin) {
        return;
    }

    const accordion = document.querySelector('body.section-index .accordion');
    if (!accordion) {
        return;
    }

    [...accordion.querySelectorAll('.accordion-collapse')].forEach((collapse_el) => {
        /** @var {Collapse} collapse */
        const collapse = bootstrap.Collapse.getOrCreateInstance(collapse_el, {toggle: false});

        collapse_el.addEventListener('shown.bs.collapse', () => {
            collapse._triggerArray[0]?.scrollIntoView({behavior: "smooth"});
        });
    });

    const link_to_previous = accordion.querySelector(`a[href="${sessionStorage.previous}"]`);
    if (link_to_previous) {
        const collapse_el = link_to_previous.closest('.accordion-collapse');
        if (collapse_el) {
            /** @var {Collapse} collapse */
            const collapse = bootstrap.Collapse.getOrCreateInstance(collapse_el, {toggle: false});
            collapse.show();
        }
    }
})();
